import { GradientDirection } from '../../../../types/ColorPicker';

type GetGradientParams = {
  color1: string;
  color2: string;
  direction: GradientDirection;
};

const DEFAULT_COLOR = '#ffffff';

export function getGradient(params: GetGradientParams) {
  const { color1, color2, direction } = params;
  if (direction === GradientDirection.circle) {
    return `radial-gradient(circle, ${color1 || DEFAULT_COLOR} 0%, ${color2 || DEFAULT_COLOR} 100%)`;
  }

  return `linear-gradient(${direction}, ${color1 || DEFAULT_COLOR} 0%, ${color2 || DEFAULT_COLOR} 100%)`;
}
